import React, { Component } from "react";
import { useEffect, useMemo, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
//import CollegueProfile from "./CollegueProfile"
import Audiobox from "./Audiobox";
import ReactTooltip from "react-tooltip";
import { withTranslation } from "react-i18next";

import axios from "axios";
const compte = localStorage.getItem("compte");
const poste = localStorage.getItem("poste");
const tabcol2 = localStorage.getItem("tabcollegue");

const tabcol = JSON.parse(tabcol2);

const token = localStorage.getItem("AccessToken");
const BackendURL = window.BackendURLCmk;

class Boitebox extends Component {
  constructor(props) {
    let Name = "";

    super(props);
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);

    this.showModal2 = this.showModal2.bind(this);
    this.hideModal2 = this.hideModal2.bind(this);
    this.hideModal3 = this.hideModal3.bind(this);

    this.state = {
      show: false,
      show2: false,
      isLoading: true,
      nom: "",
      error: null,
      boites: [],
    };
  }
  showModal() {
    this.setState({ show: true });
  }

  hideModal() {
    this.setState({ show: false });
  }

  showModal2() {
    this.setState({ show2: true });
  }
  reload = () => window.location.reload();

  hideModal2() {
    this.setState({ show2: false });
  }
  hideModal3() {
    //console.log("hi");
    this.setState({ show2: false });
    this.props.toggle();
    this.props.fetchmsgvocal();
    //this.reload();
  }
  componentDidMount() {
    this.fetchUsers(this.props.boite);
    this.fetchUserscontact(this.props.boite);
    // this.fetchUsers();
  }

  changetetat = (id) => {
    if (this.state.show2 == true) {
      var lien = window.location.href;
      // console.log(lien);
      const var2 = lien.split("/");
      //console.log("kien ici", var2[2]);
      var var4 = var2[2].split(":");
      // console.log("kien ici", var4[0]);
      var config = {
        headers: {
          Authorization: token,
        },
      };
      axios
        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/SetConsulteMessageVocallIPBXV3API?compte=${compte}&poste=${poste}&id=${id}`,
          config
        )
        .then((res) => {
          console.log("change etat succes");
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            localStorage.clear();
            var link = "/";

            window.location.replace(link);
          } else {
            console.log("AXIOS ERROR: ", err);
          }
        });
    }
  };

  formatDate = (dateString) => {
    const { t } = this.props;
    let today = new Date(dateString).setHours(0, 0, 0, 0);
    let yesterday = new Date();
    let yesterdayoftoday = yesterday.setDate(yesterday.getDate() - 1);

    let yesterday2 = new Date(yesterdayoftoday).setHours(0, 0, 0, 0);

    let d2 = new Date(dateString);
    let d1 = new Date();
    let d11 = d1.setHours(0, 0, 0, 0);

    let d22 = d2.setHours(0, 0, 0, 0);

    if ((d11.valueOf() == d22.valueOf()) == true) {
      var allDate = dateString.split(" ");
      var Datefinal = t("aujourdhui") + t("at") + " " + allDate[1];
      return Datefinal;
    }
    if ((yesterday2.valueOf() == today.valueOf()) == true) {
      var allDate = dateString.split(" ");
      var Datefinal = t("hier") + t("at") + " " + allDate[1];
      return Datefinal;
    } else {
      var allDate = dateString.split(" ");
      var thisDate = allDate[0].split("-");
      var thisTime = allDate[1].split(":");
      var newDate = [thisDate[2], thisDate[1], thisDate[0]].join("/");

      var suffix = thisTime[0] >= 12 ? "PM" : "AM";
      var hour = thisTime[0] > 12 ? thisTime[0] - 12 : thisTime[0];
      var Datefinal = t("le") + newDate + " " + t("at") + " " + allDate[1];
      return Datefinal;
    }
  };
  fetchUsers(collegue) {
    //var resultObject = search("string 1", tabcol);
    //var Noms = JSON.parse( localStorage.getItem("tabcollegue"));
    const lowercasedValue = collegue.callerid;
    // console.log(tabcol.find((x) => x.nom == lowercasedValue));7 search(nameKey, myArray){
    for (var i = 0; i < this.props.tabcol.length; i++) {
      if (this.props.tabcol[i].poste == lowercasedValue) {
        this.setState({
          nom: this.props.tabcol[i].nom,
          //isLoading: false,
        });
        // this.Name = tabcol[i].nom;
        // console.log("hola name yeey", this.Name);

        //console.log(tabcol[i]);
        // return tabcol[i];
      }
    }
  }
  fetchUserscontact = (collegue) => {
    if (this.props.tabcontact !== null) {
      const lowercasedValue = collegue.callerid;
      for (var i = 0; i < this.props.tabcontact.length; i++) {
        if (
          this.props.tabcontact[i].tel_portable == lowercasedValue ||
          this.props.tabcontact[i].tel_fix == lowercasedValue ||
          this.props.tabcontact[i].tel_3 == lowercasedValue ||
          this.props.tabcontact[i].tel_4 == lowercasedValue ||
          this.props.tabcontact[i].tel_5 == lowercasedValue
        ) {
          this.setState({
            nom: this.props.tabcontact[i].nom_prenom,
          });
        }
      }
    }
  };

  render() {
    const { t } = this.props;

    if (this.props.boite.etat == "Nouveau") {
      return (
        <div
          class="dark:bg-gray-700 dark:text-white transition-al relative rounded-lg border border-gray-500  hover:border-green-600 group bg-gray-200 px-6 py-5 hover:shadow-sm  space-x-3"
          style={{
            webKitBoxShadow:
              " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
            boxShadow:
              " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
          }}
        >
          <a href="#" class="block">
            <div class="group flex justify-between items-center">
              <div class="flex-1 flex items-center min-w-0 relative">
                <div class="ml truncate">
                  <p class="dark:text-white text-md font-medium text-gray-900 truncate">
                    {this.state.nom !== ""
                      ? this.state.nom
                      : this.props.boite.callerid}
                  </p>
                  <p class="flex dark:text-white text-md font-medium text-gray-500 truncate mr-2 my-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h5 w-5 mr-1 dark:text-white "
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      />
                    </svg>
                    {this.formatDate(this.props.boite.origtime)}
                  </p>
                  <p class="dark:text-white flex text-md font-medium text-gray-500 truncate mr-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg dark:text-white"
                      class="h-5 w-5 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    {this.props.boite.duration}
                  </p>
                </div>
              </div>
              <ReactTooltip id="playTip" place="bottom" effect="solid">
                {t("ecouter")}
              </ReactTooltip>
              <button
                data-tip
                data-for="playTip"
                type="button"
                onClick={this.showModal2}
                class="inline-flex items-center text-gray-500 group-hover:text-green-600 dark:text-white"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg dark:text-white"
                  class="h-8 w-8"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
              <Audiobox
                showModal={this.state.show2}
                handleClose={this.hideModal3}
                boite={this.props.boite.nouveau_chamain}
                id={this.props.boite.id}
              />
              {this.changetetat(this.props.boite.id)}
            </div>
          </a>
        </div>

        //
      );
    } else {
      return (
        <div
          class="dark:bg-gray-900 dark:text-white transition-al relative rounded-lg border   hover:border-green-600 group bg-white px-6 py-5 hover:shadow-sm  space-x-3"
          style={{
            webKitBoxShadow:
              " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
            boxShadow:
              " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
          }}
        >
          <a href="#" class="block">
            <div class="group flex justify-between items-center">
              <div class="flex-1 flex items-center min-w-0 relative">
                <div class="ml truncate">
                  <p class="dark:text-gray-300 text-sm font-sm text-gray-900 truncate">
                    {this.state.nom !== ""
                      ? this.state.nom
                      : this.props.boite.callerid}
                  </p>
                  {/* <div class="group flex justify-between items-center"> */}
                  <p class="flex text-sm text-gray-500 truncate mr-2 my-2">
                    {/* {this.props.boite.origtime}{" "} */}

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h5 w-5 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      />
                    </svg>
                    {this.formatDate(this.props.boite.origtime)}
                  </p>
                  <p class="flex text-sm text-gray-500 truncate mr-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    {this.props.boite.duration}
                  </p>

                  {/* </div> */}
                </div>
              </div>
              <ReactTooltip id="playTip" place="bottom" effect="solid">
                {t("ecouter")}
              </ReactTooltip>
              <button
                data-tip
                data-for="playTip"
                type="button"
                onClick={this.showModal2}
                class="inline-flex items-center text-gray-500 group-hover:text-green-600"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-8 w-8"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
              <Audiobox
                showModal={this.state.show2}
                handleClose={this.hideModal2}
                boite={this.props.boite.nouveau_chamain}
                id={this.props.boite.id}
              />
            </div>
          </a>
        </div>

        //
      );
    }
  }
}
export default withTranslation("common")(Boitebox);
